"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KlassList = void 0;
const lodash_1 = require("lodash");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const common_1 = require("../../../common");
const classes_1 = require("../../../server/classes");
const popup_1 = require("../../base/popup");
const common_2 = require("../common");
const react_i18next_1 = require("react-i18next");
const account_1 = require("../../base/account");
exports.KlassList = react_1.default.memo(({ onlyOne = false, hideMembersColumn = false, searchOption, initPage, defaultProps, classId, setClassId, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const countRef = react_1.default.useRef(10);
    const role = (0, react_redux_1.useSelector)((state) => (0, account_1.getUserRole)(state));
    const userId = (0, react_redux_1.useSelector)((state) => (0, account_1.getUserId)(state));
    const isAcademyAdmin = role === 'academy';
    const [page, setPage] = react_1.default.useState(initPage);
    const [totalCount, setTotalCount] = react_1.default.useState(120);
    const [testData, setTestData] = react_1.default.useState([]);
    const { data, refetch } = (0, classes_1.useClassesList)({
        ...(onlyOne
            ? { ...defaultProps }
            : {
                with_name: true,
                title: searchOption,
                offset: page * countRef.current,
                limit: countRef.current,
                ...(isAcademyAdmin ? { academy: userId } : {}),
            }),
        orderby: 'creation_time DESC',
    });
    const { data: enrollmentData, refetch: enrollmentRefetch } = (0, classes_1.useEnrollmentsList)(onlyOne && {
        //@ts-ignore
        member: defaultProps.belong_any,
    });
    const refetchRef = react_1.default.useRef(refetch);
    refetchRef.current = refetch;
    const enrollmentRefetchRef = react_1.default.useRef(enrollmentRefetch);
    enrollmentRefetchRef.current = enrollmentRefetch;
    // 렌더마다 throttle 인스턴스가 재생성되어 스로틀이 무효화되던 것 수정 — 단일 인스턴스 유지
    const refetchList = react_1.default.useMemo(() => (0, lodash_1.throttle)(() => refetchRef.current(), 1000), []);
    const enrollmentRefetchList = react_1.default.useMemo(() => (0, lodash_1.throttle)(() => enrollmentRefetchRef.current(), 1000), []);
    const { headTitleList, tableReadDataKeys } = react_1.default.useMemo(() => {
        // 기본적인 항목들
        const headTitleList = onlyOne
            ? [
                { title: 'className', space: 3 },
                { title: 'startDate', space: 1 },
                { title: 'endDate', space: 1 },
                { title: 'live_status', space: 1 },
                { title: 'etc', space: 1 },
            ]
            : [
                { title: 'classCode', space: 1 },
                { title: 'className', space: 3 },
                { title: 'subjectName', space: 1 },
                ...(!isAcademyAdmin ? [{ title: 'teacherName', space: 1 }] : []),
                ...(!isAcademyAdmin ? [{ title: 'live_duration', space: 2 }] : []),
                ...(!hideMembersColumn ? [{ title: 'participantMember', space: 1 }] : []),
                ...(!isAcademyAdmin ? [{ title: 'live_status', space: 1 }] : []),
            ];
        const tableReadDataKeys = onlyOne
            ? [
                { title: 'title', space: 3 },
                { title: 'startline', space: 1 },
                { title: 'deadline', space: 1 },
                { title: 'status', space: 1 },
                { title: 'etc', space: 1 },
            ]
            : [
                { title: 'identifier', space: 1 },
                { title: 'title', space: 3 },
                { title: 'subject', space: 1 },
                ...(!isAcademyAdmin ? [{ title: 'host_name', space: 1 }] : []),
                ...(!isAcademyAdmin ? [{ title: 'duration', space: 2 }] : []),
                ...(!hideMembersColumn ? [{ title: 'members', space: 1 }] : []),
                ...(!isAcademyAdmin ? [{ title: 'status', space: 1 }] : []),
            ];
        return { headTitleList, tableReadDataKeys };
    }, [onlyOne, hideMembersColumn, isAcademyAdmin]);
    react_1.default.useEffect(() => {
        setPage(initPage);
    }, [initPage]);
    react_1.default.useEffect(() => {
        onlyOne ? enrollmentRefetchList() : refetchList();
    }, [searchOption, page, onlyOne]);
    react_1.default.useEffect(() => {
        APP.eventManager.subscribe('UPDATE_KLASS_LIST', refetchList);
        return () => {
            APP.eventManager.unsubscribe('UPDATE_KLASS_LIST', refetchList);
        };
    }, []);
    react_1.default.useEffect(() => {
        if (!onlyOne && data) {
            const { total_count, items, found_count } = data;
            if (total_count > 0 && found_count === 0) {
                const maxPage = Math.max(0, Math.ceil(total_count / countRef.current) - 1);
                if (page !== maxPage) {
                    setPage(maxPage);
                    return;
                }
                // 이미 maxPage 인데도 0건 → 서버 total_count·items 불일치. 빈 목록 처리로 폴스루해
                // empty 문구가 노출되게 한다(기존: totalCount 잔존/음수 페이지로 빈 화면·페이지네이션 소실).
            }
            else {
                if (items.length > 0) {
                    setTestData(items);
                    setTotalCount(total_count);
                    return;
                }
            }
        }
        if (onlyOne && enrollmentData) {
            const { total_count, items, found_count } = enrollmentData;
            if (total_count > 0 && found_count === 0) {
                const maxPage = Math.max(0, Math.ceil(total_count / countRef.current) - 1);
                if (page !== maxPage) {
                    setPage(maxPage);
                    return;
                }
                // 이미 maxPage 인데도 0건 → 서버 total_count·items 불일치. 빈 목록 처리로 폴스루해
                // empty 문구가 노출되게 한다(기존: totalCount 잔존/음수 페이지로 빈 화면·페이지네이션 소실).
            }
            else {
                if (items.length > 0) {
                    setTestData(items);
                    setTotalCount(total_count);
                    return;
                }
            }
        }
        setTestData([]);
        setTotalCount(0);
    }, [data, enrollmentData, onlyOne, page]);
    const handlerTableClick = (title, item) => {
        switch (title) {
            case 'title':
                handlerSelectItem(item);
                break;
            case 'members':
                APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
                    component: common_2.MembersTable,
                    componentProps: {
                        id: item.id,
                        isPopup: true,
                        isModify: false,
                        defaultValues: [...item.managers, ...item.members],
                        handlerUpdateMemberIds: (member) => {
                            console.log(member);
                        },
                    },
                    title: '참여자 추가',
                    width: 800,
                    isFit: true,
                });
                break;
        }
    };
    const handlerMoreData = (page) => {
        setPage(page);
        APP.eventManager.publish('UPDATE_PAGE', page);
    };
    const handlerSelectItem = (item) => {
        APP.eventManager.publish('CHANGE_MENU', {
            showDepth: 'detail',
            props: { id: item.id },
        });
    };
    const renderEmpty = react_1.default.useMemo(() => totalCount <= 0 && (react_1.default.createElement("div", { className: "empty_data" },
        react_1.default.createElement("p", null, "\uB4F1\uB85D\uB41C \uD074\uB798\uC2A4\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."))), [totalCount]);
    const renderItem = (item) => {
        if (!item)
            return;
        return tableReadDataKeys.map((headItem, idx) => (react_1.default.createElement("div", { key: idx, className: "table-item", style: {
                flex: headItem.space,
                justifyContent: 'flex-start',
                alignItems: 'center',
                display: 'flex',
                overflow: 'hidden',
                cursor: headItem.title === 'title' || headItem.title === 'members'
                    ? 'pointer'
                    : 'default',
            }, onClick: () => handlerTableClick(headItem.title, item) }, (() => {
            switch (headItem.title) {
                case 'duration':
                    return (react_1.default.createElement("p", { className: "overText2" }, `${(0, moment_1.default)(item.startline).format('YYYY-MM-DD')} ~ ${(0, moment_1.default)(item.deadline).format('YYYY-MM-DD')}`));
                case 'title':
                    return (react_1.default.createElement("p", { className: `overText2 ${onlyOne ? '' : 'underline'}` }, item[headItem.title]));
                case 'status':
                    return (react_1.default.createElement("p", { className: "overText" }, item[headItem.title] === 'inactive'
                        ? t(`status.${item[headItem.title]}`)
                        : t(`status.active`)));
                case 'members':
                    return (react_1.default.createElement("p", { className: `overText2 ${onlyOne ? '' : 'underline underline_pink'}` }, "\uCC38\uC5EC\uC790 \uCD94\uAC00"));
                case 'startline':
                case 'deadline':
                    return (react_1.default.createElement("p", { className: "overText2" }, (0, moment_1.default)(item[headItem.title]).format('YYYY-MM-DD')));
                case 'etc':
                    return (react_1.default.createElement("p", { className: `overText2 ${classId === item.id ? 'underline_pink' : 'underline'}`, style: { cursor: 'pointer' }, onClick: () => setClassId(item.id) }, "\uC790\uC138\uD788 \uBCF4\uAE30"));
                default:
                    return react_1.default.createElement("p", { className: "overText2" }, item[headItem.title]);
            }
        })())));
    };
    return (react_1.default.createElement(common_1.Table, { className: `${onlyOne ? 'table-white-grey' : ''}`, showIndex: true, indexOrder: "desc", isInnerPage: true, isInfinite: false, page: page, data: testData, totalCount: totalCount, headTitleList: headTitleList, renderItem: renderItem, renderEmpty: renderEmpty, handlerMoreData: handlerMoreData }));
});
